import "./index.es468.js";
import "./index.es469.js";
import "./index.es470.js";
import "./index.es471.js";
import "./index.es472.js";
import { MIGRATION_TREND_ZOOM_DETAILS as e, MIGRATION_POPULATION_PERCENT_CHANGE_STATIC_CBSA_COUNTY_BINS as t, MIGRATION_POPULATION_PERCENT_CHANGE_STATIC_ZIPCODE_BINS as a, MIGRATION_POPULATION_CHANGE_STATIC_CBSA_BINS as r, MIGRATION_POPULATION_CHANGE_STATIC_COUNTY_BINS as n, MIGRATION_POPULATION_CHANGE_STATIC_ZIPCODE_BINS as g, NET_MIGRATION_STATIC_CBSA_BINS as c, NET_MIGRATION_STATIC_COUNTY_BINS as _, NET_MIGRATION_STATIC_ZIPCODE_BINS as l, MIGRATION_TREND_ZOOM_DETAILS_0504 as i } from "./index.es479.js";
import "./index.es473.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es474.js";
import "./index.es478.js";
const o = {
  migrationNetMigration: {
    id: "migrationNetMigration",
    name: "Net Migration",
    disabledText: "",
    layerCategory: "Migration Trends",
    dataSource: "Placer.ai, Dec. 2023 to Dec. 2024",
    tileSource: "migration_placer_2025",
    tileCategory: "premium",
    propertyKey: "total_migration",
    labelRounding: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "# of People, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: [],
      zipcode: l,
      county: _,
      cbsa: c
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  migrationPopulationChange: {
    id: "migrationPopulationChange",
    name: "Population Change",
    disabledText: "",
    layerCategory: "Migration Trends",
    dataSource: "Placer.ai, Dec. 2023 to Dec. 2024",
    tileSource: "migration_placer_2025",
    tileCategory: "premium",
    propertyKey: "total_pop_change",
    labelRounding: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "# of People, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: [],
      zipcode: g,
      county: n,
      cbsa: r
    },
    zoomDetails: e,
    vizType: "choropleth"
  },
  migrationPopulationPercentChange: {
    id: "migrationPopulationPercentChange",
    name: "Population Percent Change",
    disabledText: "",
    layerCategory: "Migration Trends",
    dataSource: "Placer.ai, Dec. 2023 to Dec. 2024",
    tileSource: "migration_placer_2025",
    tileCategory: "premium",
    propertyKey: "total_pop_change_percentage",
    propertyUnit: "%",
    propertyValueScale: 1,
    labelRounding: 1,
    legendRangeType: "Numeric",
    legendDescPrefix: "% of People, ",
    bucketingMode: "staticRange",
    staticRangeBucketingConfig: {
      cbg: [],
      zipcode: a,
      county: t,
      cbsa: t
    },
    zoomDetails: e,
    vizType: "choropleth"
  }
}, d = {
  migrationNetMigration: {
    ...o.migrationNetMigration,
    tileSource: "migration_placer_202504",
    dataSource: "Placer.ai, Feb 2024 to Feb 2025",
    zoomDetails: i
  },
  migrationPopulationChange: {
    ...o.migrationPopulationChange,
    tileSource: "migration_placer_202504",
    dataSource: "Placer.ai, Feb 2024 to Feb 2025",
    zoomDetails: i
  },
  migrationPopulationPercentChange: {
    ...o.migrationPopulationPercentChange,
    tileSource: "migration_placer_202504",
    dataSource: "Placer.ai, Feb 2024 to Feb 2025",
    zoomDetails: i
  }
};
export {
  o as MIGRATION_TRENDS_LAYER_INFO,
  d as MIGRATION_TRENDS_LAYER_INFO_202504
};
//# sourceMappingURL=index.es298.js.map
